export const getDateFormatted = (d: number) => {
  return new Date(d * 1000).toLocaleDateString("en-CA", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
